import PropTypes from "prop-types"
import { InputAdornment, TextField, FormControlLabel, Checkbox } from "@material-ui/core"
import { NumericFormat } from "react-number-format"
import { formatInputValuesToDefault } from "../../../../utils/financialHelper"
import SelectBancos from "../../../../components/Financial/SelectBancos"
import CrudFormPage from "../../../../components/Financial/CrudFormPage"

const FormContasCorrentesCrud = ({ values, setValues, isDelete: isDisabled, isLoadingSubmit = false }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: formatInputValuesToDefault(value) });
  }

  return (
    <CrudFormPage isLoadingSubmit={isLoadingSubmit}>
      <SelectBancos onChange={handleChange} banco={values.bankCode} isDelete={isDisabled} />
      <div className='linha-campos'>
        <TextField
          label="Agência"
          id='agencia'
          name='agencia'
          value={values.agencia}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          required
          fullWidth
          disabled={isDisabled}
        />
        <TextField
          label="Conta"
          id='conta'
          name='conta'
          value={values.conta}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          required
          fullWidth
          disabled={isDisabled}
        />
      </div>
      <TextField
        label="Descrição"
        id="descricao"
        name='descricao'
        value={values.descricao}
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        onChange={handleChange}
        disabled={isDisabled}
      />
      <div className='linha-campos'>
        <NumericFormat
          customInput={TextField}
          label="Saldo inicial"
          id='initialBalance'
          name='initialBalance'
          value={values.initialBalance ?? ''}
          variant="outlined"
          InputProps={{
            endAdornment: <InputAdornment position="start">R$</InputAdornment>,
          }}
          fullWidth
          disabled={isDisabled}
          decimalSeparator=","
          decimalScale={2}
          autoComplete="off"
          onChange={handleChange}
          required
        />
        <TextField
          label="Data do saldo"
          id='initialBalanceDate'
          name='initialBalanceDate'
          value={values.initialBalanceDate}
          variant="outlined"
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          required
          fullWidth
          disabled={isDisabled}
          type='date'
        />
      </div>

      <div className='linha-campos'>
        <FormControlLabel
          control={
            <Checkbox
              checked={values.status}
              onChange={(e) => setValues({ ...values, status: e.target.checked })}
              color="default"
            />
          }
          label="Conta ativa"
    />
        <FormControlLabel
          control={
            <Checkbox
              checked={values.showReportClosing}
              onChange={(e) => setValues({ ...values, showReportClosing: e.target.checked })}
              color="default"
            />
          }
          label="Exibir nos relatórios de fechamento"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={values.showReportEvolution}
              onChange={(e) => setValues({ ...values, showReportEvolution: e.target.checked })}
              color="default"
            />
          }
          label="Exibir no relatório de evolução patrimonial"
        />        
      </div>
    </CrudFormPage>
  )
}

FormContasCorrentesCrud.propTypes = {
  values: PropTypes.shape({
    id: PropTypes.number,
    banco: PropTypes.string.isRequired,
    bankCode: PropTypes.number,
    agencia: PropTypes.string.isRequired,
    conta: PropTypes.string.isRequired,
    descricao: PropTypes.string.isRequired,
    actions: PropTypes.string,
    initialBalance: PropTypes.number,
    initialBalanceDate: PropTypes.string,
    status: PropTypes.bool,
    showReportClosing: PropTypes.bool,
    showReportEvolution: PropTypes.bool,
  }).isRequired,
  setValues: PropTypes.func.isRequired,
  isDelete: PropTypes.bool.isRequired,
  isLoadingSubmit: PropTypes.bool.isRequired,
}

export default FormContasCorrentesCrud